import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) return <p>Loading...</p>;

  // ✅ Check context user first, fallback to localStorage if context is null
  let currentUser = user;
  if (!currentUser) {
    try {
      const savedUser = localStorage.getItem("user");
      if (savedUser) {
        currentUser = JSON.parse(savedUser);
      }
    } catch (e) {
      console.log("Error parsing saved user", e);
    }
  }

  if (!currentUser) {
    console.log("[ProtectedRoute] No user found, redirecting to sign-in");
    return <Navigate to="/auth/sign-in" />;
  }
  
  if (!allowedRoles.includes(currentUser.role)) {
    console.log("[ProtectedRoute] User role not allowed:", currentUser.role);
    return <Navigate to="/auth/sign-in" />;
  }

  return children;
};

export default ProtectedRoute;
